import {NgModule} from "@angular/core";
import {BuyerRoutingModule} from "./buyer-routing.module";
import {BuyerComponent} from "./buyer/buyer.component";
import {CheckoutComponent} from "./checkout/checkout.component";
import {OrdersComponent} from "./orders/orders.component";
import {RFQComponent} from "./rfq/rfq.component";
import {ListRFQComponent} from "./list-rfq/list-rfq.component";
import {OnebillCheckoutComponent} from "./onebill-checkout/onebill-checkout.component";
import {SharedModule} from "../../shared/shared.module";
import {UpdateUserComponent} from "./user/update-user/update-user.component";
import {UpdatePasswordComponent} from "./user/update-password/update-password.component";
import {AccountStatusComponent} from "./user/account-status/account-status.component";
import {LicenseComponent} from './license/license.component';
import { OnebillPaymentComponent } from './onebill-payment/onebill-payment.component';
import {NotificationsListComponent} from "./notifications/notifications-list/notifications-list.component";
import {NotificationsBarComponent} from "./notifications/notifications-bar/notifications-bar.component";
import { EditRfqComponent } from './edit-rfq/edit-rfq.component';
import {CommerceComponent} from "./commerce/commerce.component";
import {ListQuotationsComponent} from "./list-quotations/list-quotations.component";
import {QuotationComponent} from "./quotation/quotation.component";
import {CreateLeadComponent} from "./create-lead/create-lead.component";

@NgModule({
  imports: [
    SharedModule,
    BuyerRoutingModule
  ],
  declarations: [
    BuyerComponent, CheckoutComponent, OrdersComponent, RFQComponent, ListRFQComponent, OnebillPaymentComponent,
    OnebillCheckoutComponent, UpdateUserComponent, UpdatePasswordComponent, AccountStatusComponent, LicenseComponent,
    NotificationsListComponent, NotificationsBarComponent, EditRfqComponent, CommerceComponent,
    ListQuotationsComponent, QuotationComponent, CreateLeadComponent
  ]
})
export class BuyerModule {
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/buyer.module.ts